import { useNavigate, useParams } from 'react-router-dom';
import { useGetModulesWithCategoriesQuery } from '../../graphql/schema';
import Loading from '../base/Loading';
import { fal as icons } from '@fortawesome/pro-light-svg-icons';
import SidebarItem from '../sidebar/SidebarItem';
import SidebarItemsContainer from '../sidebar/SidebarItemsContainer';

const TaskDefinitionsSidebar = () => {
  const navigate = useNavigate();
  const { moduleId, categoryId } = useParams();

  const { data, loading } = useGetModulesWithCategoriesQuery();

  if (loading) return <Loading />;

  return (
    <SidebarItemsContainer>
      {data?.modulesWithCategories
        .map((m) => m)
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((module) => (
          <SidebarItem
            key={module.id}
            label={module.title}
            onClick={() => navigate(`/module/${module.id}`)}
            isActive={module.id === moduleId}
            activeChildKey={categoryId}
            childItems={module.categories
              ?.map((c) => c)
              .sort((a, b) => a.title.localeCompare(b.title))
              .map((category) => ({
                label: category.title,
                key: category.id,
                icon: icons[category.icon],
                onClick: () => navigate(`/module/${module.id}/${category.id}`),
              }))}
          />
        ))}
    </SidebarItemsContainer>
  );
};

export default TaskDefinitionsSidebar;
